import React, { useContext, useState } from 'react';

interface SellersParamsContextProps {
  params?: {
    SealId?: string,
    IsConfi?: string,
    KeyWord?: string,
    PageNumber?: number,
    RowsPerPage?: number,
  }
  setParams?: React.Dispatch<any>,
}
const DEFULT_SELLERS_CONTEXT_PROPS:SellersParamsContextProps = {}
const SellersParamsContext = React.createContext<SellersParamsContextProps>(DEFULT_SELLERS_CONTEXT_PROPS);

const SellersParamsProvider = ({children}: any) => {
  const [SellersParamsContextParams, setSellersParamsContextParams] = useState(DEFULT_SELLERS_CONTEXT_PROPS.params);

  return (
    <SellersParamsContext.Provider
      value={{
        params: SellersParamsContextParams,
        setParams: setSellersParamsContextParams,
      }}
    >
      {children}
    </SellersParamsContext.Provider>
  )
}

const useSellersParams = () => {
  const context = useContext(SellersParamsContext);
  if (context === undefined) throw new Error('context must be used within a useTablePriceList');
  return context;
}

export {SellersParamsContext, SellersParamsProvider, useSellersParams}